import React, { useState } from 'react'
import { ReactComponent as Stars } from '../../../assets/early/svg/Stars.svg'
import { ReactComponent as BackButtonClassroom } from '../../../assets/early/svg/BackButtonClassroom.svg'
import { ReactComponent as ClassroomSettingsButton } from '../../../assets/early/svg/ClassroomSettingsButton.svg'
import SecretKeyModal from '../modals/SecretKeyModal'
import { useHistory } from 'react-router-dom'
import '../../../styles/early/earlyMotion.css'

function Header({ text = '', showSettingsButton = false, passingData = {}, securityEnabled = false }) {
    const [modalVisible, setModalVisible] = useState(false)
    const [callbackFunctionType, setCallbackFunctionType] = useState('back')
    let history = useHistory()

    const goBack = () => {
        if (securityEnabled && false) {
            setModalVisible(true)
            setCallbackFunctionType('back')
        } else goBackFunction()
    }

    const goBackFunction = () => {
        history.goBack()
    }

    const openSettingsFunction = () => {
        history.push(`/early/classroom/student-settings?id=${passingData?.id}`)
    }

    const openSettings = () => {
        if (securityEnabled && false) {
            setModalVisible(true)
            setCallbackFunctionType('settings')
        } else openSettingsFunction()
    }

    const callbackFunction = () => {
        if (callbackFunctionType == 'back') goBackFunction()
        else openSettingsFunction()
    }
    return (
        <div className="relative">
            <div className=" w-full bg-[linear-gradient(90.7deg,#212662_-1.66%,rgba(94,99,155,0.74)_107.24%)] absolute z-0">
                <Stars width={'100%'} height={80} />
            </div>
            <div className=" relative flex flex-col">
                <div className=" px-[25px] flex flex-row items-center justify-between py-[10px]">
                    <button className="flex flex-row items-center justify-center gap-2 rounded-full bg-[#FFFFFF] p-[10px] pr-[40px] em-tap" onClick={goBack}>
                        <BackButtonClassroom />
                        <p className="text-[18px] leading-8 font-bold text-[#413F5E]">{text}</p>
                    </button>
                    {/* {showSettingsButton && (
                        <button onClick={openSettings}>
                            <ClassroomSettingsButton />
                        </button>
                    )} */}
                </div>
                <div className="bg-[#FDDF6D] shadow-[inset_0px_4px_4px_0px_#00000040] h-[5px] w-full"></div>
            </div>
            <SecretKeyModal modalVisible={modalVisible} setModalVisible={setModalVisible} callbackFunction={callbackFunction} callbackFunctionType={callbackFunctionType} />
        </div>
    )
}

export default Header
